import React from 'react';

import { Col } from 'antd';

import { fieldIsBlock, FieldsActionBR, FieldsNameBR } from '../../constants';
import type { ChangeLogHistory, ChangeLogHistoryItemValue } from '../../constants';
import formatHistoryInfo from '../formatters';

type HistoryDetailsItemsSubFields = {
  history: ChangeLogHistory;
};

function HistoryDetailsItemsSubFields({ history }: HistoryDetailsItemsSubFields) {
  const { field, values } = history;

  const fieldHasBooleanValue = typeof field === 'boolean';

  return (
    <>
      {values.map(change => {
        const changeAlias = change.alias;
        const changeValues = change.values;

        const getValueItem = (item: ChangeLogHistoryItemValue) => {
          const haveOnlyTo = item.action === 'add';
          const showFrom = !fieldHasBooleanValue || !haveOnlyTo;
          const showTo = !fieldHasBooleanValue;

          return (
            <div
              className='flex data-[block=true]:flex-col max-sm:flex-col [&>div]:flex [&>div]:items-center'
              data-block={fieldIsBlock.includes(field)}
              key={field}
            >
              <div>
                <p className='inline-block bg-[#FFFCE6] text-base'>{FieldsActionBR[item.action]}</p>
              </div>
              <div>
                <p className='text-base'>{FieldsNameBR[item.field as keyof typeof FieldsNameBR]}</p>
              </div>
              {showFrom && (
                <div>
                  <p className='text-base text-[#00000073] line-through [line-break:anywhere] [&_img]:opacity-50'>
                    {formatHistoryInfo(item.field, item.from)}
                  </p>
                </div>
              )}
              {showTo && (
                <div>
                  <p className='text-base [line-break:anywhere]'>{formatHistoryInfo(item.field, item.to)}</p>
                </div>
              )}
            </div>
          );
        };

        return (
          <Col key={field} span={24}>
            <div className='flex flex-col [&_p]:p-1 [&:not(:last-child)]:pb-6'>
              <div className='grow'>
                <p className='text-base'>
                  {changeAlias ?? FieldsNameBR[field as keyof typeof FieldsNameBR]}
                  {!!history?.status && ` - ${history.status}`}
                </p>
              </div>
              {changeValues.map(changeValue => getValueItem(changeValue))}
            </div>
          </Col>
        );
      })}
    </>
  );
}

export default HistoryDetailsItemsSubFields;
